"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsClient = void 0;
const tslib_1 = require("tslib");
const new_crud_client_1 = require("./new.crud.client");
const to_date_time_string_1 = require("./utils/to-date-time-string");
class AccountsClient extends new_crud_client_1.NewCrudClient {
    constructor() {
        super(...arguments);
        this.urlTemplate = '/v1/accounts';
    }
    getUsersByAccount(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { accountId } = request, params = tslib_1.__rest(request, ["accountId"]);
            const response = yield this.httpGet(`/v1/accounts/${accountId}/users?${this.getQueryString(params)}`);
            return response.payload || [];
        });
    }
    getTeamsByAccount(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { accountId } = request, params = tslib_1.__rest(request, ["accountId"]);
            const response = yield this.httpGet(`/v1/accounts/${accountId}/teams?${this.getQueryString(params)}`);
            return response.payload || [];
        });
    }
    getProjectsByAccount(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { accountId } = request, params = tslib_1.__rest(request, ["accountId"]);
            const response = yield this.httpGet(`/v1/accounts/${accountId}/projects?${this.getQueryString(params)}`);
            return response.payload || [];
        });
    }
    getRoles(accountId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/accounts/${accountId}/roles`);
            return response.payload;
        });
    }
    setParameters(accountId, parameters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/accounts/${accountId}/parameters`, parameters);
            return response.payload;
        });
    }
    getParameters(accountId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/accounts/${accountId}/parameters`);
            return response.payload;
        });
    }
    migrateAccount(sourceId, targetId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/accounts/migrate`, { sourceId, targetId });
            return response.payload;
        });
    }
    getFlags(accountId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/accounts/${accountId}/flags`, {
                throwOnError: false,
            });
            if (response.success) {
                return response.payload;
            }
        });
    }
    updateFlags(accountId, flags) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/accounts/${accountId}/flags`, flags);
            return response.payload;
        });
    }
    setFlags(accountId, flags) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/accounts/${accountId}/flags`, flags);
            return response.payload;
        });
    }
    getPageviewQuota(accountId, from, to) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParams = [];
            if (from) {
                queryParams.push(`from=${(0, to_date_time_string_1.toDateTimeString)(from)}`);
            }
            if (to) {
                queryParams.push(`to=${(0, to_date_time_string_1.toDateTimeString)(to)}`);
            }
            const response = yield this.httpGet(`/v1/accounts/${accountId}/pageview/quota?${queryParams.join('&')}`);
            return response.payload;
        });
    }
    getPageviewConsumption(accountId, query) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { from, to, projectIds, period } = query;
            const response = yield this.httpGet(`/v1/accounts/${accountId}/pageview/consumption?from=${from}&to=${to}` +
                (projectIds ? `&projectIds=${projectIds}` : '') +
                (period ? `&period=${period}` : ''));
            return response.payload;
        });
    }
    updateAuthenticationMethod(accountId, authenticationMethod) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/accounts/${accountId}/authentication-method`, { authenticationMethod });
            return response.payload;
        });
    }
    updateStatus(accountId, status) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/accounts/${accountId}/status`, { status });
            return response.payload;
        });
    }
}
exports.AccountsClient = AccountsClient;
//# sourceMappingURL=accounts.client.js.map